import { Environment } from "@app/environment.interface";

export const environment: Environment = {
  production: true,
  devEnvironment: false
};
